export default __webpack_public_path__ + "static/media/bellIconHC.0548ffa0.svg";